import { Box, IconButton, Menu, MenuItem, PopoverOrigin } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ReactElement, ReactNode, useState, MouseEvent, Children, isValidElement } from 'react';

export interface DropdownOptionsProps {
  callback: () => void;
  label: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function DropdownOption(props: DropdownOptionsProps): ReactElement {
  return <></>;
}

export interface IClickOutsideProps {
  children: ReactNode;
  wrapperId?: string;
  listen: boolean;
}

interface MoreDropdownProps {
  'data-testid'?: string;
  maintainChildren?: boolean;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  customAnchorElement?: null | HTMLElement;
  children?: ReactElement<DropdownOptionsProps> | ReactElement<DropdownOptionsProps>[];
}

export function MoreDropdown({
  'data-testid': testId = undefined,
  maintainChildren = false,
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  transformOrigin = { vertical: 'top', horizontal: 'right' },
  customAnchorElement,
  children,
}: MoreDropdownProps): ReactElement {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(customAnchorElement ? customAnchorElement : event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        data-testid={testId}
        aria-label="more"
        id="more-button"
        aria-controls={open ? 'menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="menu"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {maintainChildren ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', px: '10px' }}>
            {Children.map(children, (child) => {
              return child;
            })}
          </Box>
        ) : (
          Children.map(children, (child) => {
            if (isValidElement(child)) {
              return (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    child.props.callback();
                  }}
                >
                  {child.props.label}
                </MenuItem>
              );
            }

            return child;
          })
        )}
      </Menu>
    </div>
  );
}
